import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuestComponent } from './simple-icons-quest.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuestComponent ],
    exports:      [ SimpleIconsQuestComponent ],
    bootstrap:    []
})
export class SimpleIconsQuestModule {}
